let memoizedColumns = new Map()
const WorkAllocationColumn = (header) => {
    if (memoizedColumns.has(header)) {
        return memoizedColumns.get(header)
    }

    let allColumns = [
        {
            accessorKey: 'audit_date',
            header: 'Audit Date',
            parent: ['Pending', 'Completed', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            accessorKey: 'review_date',
            header: 'Review Date',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock'],
        },
        {
            accessorKey: 'patient_name',
            header: 'Patient Name',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'mr_number',
            header: 'MR Number',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'payor_type',
            header: 'Payor Type',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'assessment_type',
            header: 'Assessment Type',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'age_chart',
            header: 'Age of Chart',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'chart_status',
            header: 'Chart Status',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'm1021',
            header: 'M1021(PDX)',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'priority',
            header: 'Priority',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'coder_name',
            header: 'Coder Name',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'qa',
            header: 'QA',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'prod_tl',
            header: 'Prod TL',
            parent: ['Pending', 'Completed', 'Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'qa_tl',
            header: 'QA TL',
            parent: ['Locked', 'Coding Post Problem', 'Appeals', 'Ready For Lock', 'Technical Issue', 'Hold'],
        },
        {
            accessorKey: 'chart_lock_issue',
            header: 'Chart Lock Issue',
            parent: ['Locked', 'Ready For Lock', 'Completed'],
        },
        {
            accessorKey: 'chart_locked_user',
            header: 'Chart Locked User',
            parent: ['Locked', 'Ready For Lock', 'Completed'],
        },
        {
            accessorKey: 'chart_locked_date',
            header: 'Chart Lock Date',
            parent: ['Locked', 'Ready For Lock', 'Completed'],
        },
        {
            accessorKey: 'query_status',
            header: 'Query Status',
            parent: ['Coding Post Problem'],
        },
        {
            accessorKey: 'query_date',
            header: 'Query Date',
            parent: ['Coding Post Problem'],
        },
        {
            accessorKey: 'tioc_query_status',
            header: 'TIOC Query Status',
            parent: ['Coding Post Problem'],
        },
        {
            accessorKey: 'tioc_query_date',
            header: 'TIOC Query Date',
            parent: ['Coding Post Problem'],
        },
       
    ]
    let currentHeaderColumn = allColumns.filter((column) => {
        return column.parent.includes(header)
    })
    memoizedColumns.set(header, currentHeaderColumn)
    return currentHeaderColumn
}

export default WorkAllocationColumn
